// extracted by mini-css-extract-plugin
module.exports =  {"statCard":"statCard__9PWhN","statCardTitle":"statCardTitle__xFwNL","statCardItem":"statCardItem__qGC10"};